var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import Component from 'vue-class-component';
import kintaiKanri from '../../ts/kintaiKanri';
import ConfirmationModal from './ConfirmationModal.vue';
import Clock from './Clock.vue';
// CommonJS
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
// コンポーネントの設定
var MyPage = /** @class */ (function (_super) {
    __extends(MyPage, _super);
    function MyPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.kintai = new kintaiKanri();
        _this.intime = "";
        _this.indate = "";
        _this.outtime = "";
        _this.outdate = "";
        _this.icon_in = './static/img/timecard/icon_in.png';
        _this.icon_out = './static/img/timecard/icon_out.png';
        return _this;
    }
    MyPage.prototype.mounted = function () {
        this.kintai.getStatus();
    };
    MyPage.prototype.setDate = function () {
        this.$data.date = new Date();
    };
    MyPage.prototype.openInModal = function () {
        this.kintai.setPlaceholder();
        this.$data.in_modal = true;
        this.getCurrentTime();
    };
    MyPage.prototype.openOutModal = function () {
        this.kintai.setPlaceholder();
        this.$data.out_modal = true;
        this.getCurrentTime();
    };
    MyPage.prototype.openResultModal = function () {
        this.$data.result_modal = true;
    };
    MyPage.prototype.getCurrentTime = function () {
        this.$data.in_date = this.kintai.today;
        this.$data.in_time.HH = this.kintai.HH;
        this.$data.in_time.mm = this.kintai.mm;
        this.$data.out_date = this.kintai.today;
        this.$data.out_time.HH = this.kintai.HH;
        this.$data.out_time.mm = this.kintai.mm;
    };
    MyPage.prototype.closeModal = function () {
        this.$data.in_modal = false;
        this.$data.out_modal = false;
        this.$data.forgetting_flag = false;
        this.$data.result_modal = false;
    };
    MyPage.prototype.sendIn = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, result, message, request_1, url, time, date, flag, request_url;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.intime = this.$data.in_time.HH + ":" + this.$data.in_time.mm;
                        this.indate = this.$data.in_date;
                        if (!(this.intime.length == 5 && this.indate.length == 10)) return [3 /*break*/, 2];
                        console.log("in sign in");
                        return [4 /*yield*/, this.kintai.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        result = "";
                        message = "";
                        request_1 = new XMLHttpRequest();
                        url = this.$data.kintai.helper.path + "auth_users/in/" + this.$data.kintai.address;
                        time = "?&in_time=" + this.intime;
                        date = "&date=" + this.indate;
                        flag = "&forgetting_flag=";
                        if (this.$data.forgetting_flag) {
                            flag = flag + 1;
                        }
                        else {
                            flag = flag + 0;
                        }
                        request_url = url + time + date + flag;
                        console.log(request_url);
                        request_1.open('GET', request_url);
                        request_1.setRequestHeader("Content-Type", "application/json");
                        request_1.setRequestHeader("access-token", access_token);
                        request_1.setRequestHeader("uid", uid);
                        request_1.setRequestHeader("client", client);
                        request_1.onreadystatechange = function () {
                            if (request_1.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_1.status != 200) {
                                // 失敗
                                console.log('失敗');
                                result = request_1.responseText;
                                message = request_1.response;
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                result = request_1.responseText;
                                message = request_1.response;
                                console.log(request_1);
                            }
                        };
                        request_1.send(null);
                        setTimeout(function () {
                            if (result == '{"errors":["アカウント登録もしくはログインしてください。"]}') {
                                _this.kintai.helper.deleteLocalStrage();
                            }
                            else {
                                _this.kintai.getStatusFromAPI()
                                    .then(function (result) {
                                    _this.kintai.setStatus(result, "TimeCard");
                                });
                            }
                            _this.closeModal();
                            _this.$data.result = message;
                            _this.openResultModal();
                        }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        alert('時間を入力してください');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MyPage.prototype.checkSendOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var outdate_y, outdate_m, outdate_d, out_at_date, result;
            return __generator(this, function (_a) {
                this.outtime = this.$data.out_time.HH + ":" + this.$data.out_time.mm;
                this.outdate = this.$data.out_date;
                outdate_y = parseInt(this.outdate.slice(0, 4));
                outdate_m = parseInt(this.outdate.slice(5, 7));
                outdate_d = parseInt(this.outdate.slice(8, 10));
                out_at_date = new Date(outdate_y, outdate_m, outdate_d, this.$data.out_time.HH, this.$data.out_time.mm);
                console.log(out_at_date);
                console.log(this.kintai.in_at_date);
                if (this.kintai.in_at_date != "Invalid Date") { //update前対応
                    if (out_at_date.getTime() - this.kintai.in_at_date.getTime() > 86400000) {
                        console.log("一日超えてる");
                        result = confirm('勤務時間が24時間を超えています。よろしいですか？');
                        if (result) {
                            //はいを選んだときの処理
                            this.sendOut(this.outtime);
                        }
                        else {
                            this.closeModal();
                        }
                    }
                    else {
                        this.sendOut(this.outtime);
                    }
                }
                else {
                    this.sendOut(this.outtime);
                }
                return [2 /*return*/];
            });
        });
    };
    MyPage.prototype.sendOut = function (outtime) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, access_token, uid, client, request_2, result, message, url, time, date, flag, request_url;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(outtime.length == 5 && this.outdate.length == 10)) return [3 /*break*/, 2];
                        console.log("in sendout");
                        return [4 /*yield*/, this.kintai.helper.loadHeaders()];
                    case 1:
                        headers = _a.sent();
                        access_token = headers["access-token"];
                        uid = headers["uid"];
                        client = headers["client"];
                        request_2 = new XMLHttpRequest();
                        result = "";
                        message = "エラー";
                        url = this.$data.kintai.helper.path + "auth_users/out/" + this.$data.kintai.address;
                        time = "?&out_time=" + this.outtime;
                        date = "&date=" + this.outdate;
                        flag = "&forgetting_flag=";
                        if (this.$data.forgetting_flag) {
                            flag = flag + 1;
                        }
                        else {
                            flag = flag + 0;
                        }
                        request_url = url + time + date + flag;
                        console.log(request_url);
                        request_2.open('GET', request_url);
                        request_2.setRequestHeader("Content-Type", "application/json");
                        request_2.setRequestHeader("access-token", access_token);
                        request_2.setRequestHeader("uid", uid);
                        request_2.setRequestHeader("client", client);
                        request_2.onreadystatechange = function () {
                            if (request_2.readyState != 4) {
                                // リクエスト中
                                console.log('リクエスト中');
                            }
                            else if (request_2.status != 200) {
                                // 失敗
                                console.log('失敗');
                                result = request_2.responseText;
                                message = request_2.response;
                            }
                            else {
                                // 取得成功
                                console.log('取得成功');
                                result = request_2.responseText;
                                message = request_2.response;
                                console.log(request_2);
                            }
                        };
                        request_2.send(null);
                        setTimeout(function () {
                            if (result == '{"errors":["アカウント登録もしくはログインしてください。"]}') {
                                _this.kintai.helper.deleteLocalStrage();
                            }
                            else {
                                _this.kintai.getStatusFromAPI()
                                    .then(function (result) {
                                    _this.kintai.setStatus(result, "TimeCard");
                                });
                            }
                            _this.closeModal();
                            _this.$data.result = message;
                            _this.openResultModal();
                        }, 1500);
                        return [3 /*break*/, 3];
                    case 2:
                        alert('時間を入力してください');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MyPage.prototype.updateStatus = function () {
        var _this = this;
        this.kintai.getStatusFromAPI()
            .then(function (result) {
            _this.kintai.setStatus(result, "TimeCard");
        });
    };
    MyPage = __decorate([
        Component({
            name: 'time_card',
            data: function () { return ({
                title: "タイムカード",
                in_modal: false,
                out_modal: false,
                result_modal: false,
                in_date: '',
                out_date: '',
                in_time: {
                    HH: '00',
                    mm: '00',
                },
                out_time: {
                    HH: '00',
                    mm: '00',
                },
                forgetting_flag: false,
                date: new Date,
                result: '',
                last_data: [],
            }); },
            methods: {
                changeCheckbox: function (event) {
                    if (this.$data.forgetting_flag) {
                        var today = new Date();
                        var year = today.getFullYear();
                        var month = ("0" + (today.getMonth() + 1)).slice(-2);
                        var day = ("0" + today.getDate()).slice(-2);
                        var date = year + "-" + month + "-" + day;
                        var HH = ('0' + today.getHours()).slice(-2);
                        var mm = ('0' + today.getMinutes()).slice(-2);
                        this.$data.in_date = date;
                        this.$data.in_time.HH = HH;
                        this.$data.in_time.mm = mm;
                        this.$data.out_date = date;
                        this.$data.out_time.HH = HH;
                        this.$data.out_time.mm = mm;
                    }
                },
            },
            watch: {
                date: function (val) {
                    //this.$data.out_time.mm = ('0' + val.getSeconds()).slice(-2)
                }
            },
            components: { VueTimepicker: VueTimepicker, ConfirmationModal: ConfirmationModal, Clock: Clock },
        })
    ], MyPage);
    return MyPage;
}(Vue));
export default MyPage;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/TimeCard.vue
// module id = 269
// module chunks = 1